"use client"

import { Container, SimpleGrid, Box, Text, Group } from "@forestsync/ui"
import { TbLeaf, TbArrowsExchange, TbTrees, TbArrowRight } from "react-icons/tb"
import { useRouter } from "next/navigation"
import { useTranslations } from "next-intl"
import { ActionCard } from "@forestsync/ui"

export function LandingPathways() {
  const t = useTranslations("landing")
  const router = useRouter()

  const pathways = [
    {
      icon: TbLeaf,
      color: "forest",
      title: t("pathBuyTitle"),
      description: t("pathBuyDesc"),
      cta: t("pathBuyCta"),
      href: "/market",
    },
    {
      icon: TbArrowsExchange,
      color: "sage",
      title: t("pathTradeTitle"),
      description: t("pathTradeDesc"),
      cta: t("pathTradeCta"),
      href: "/register?intent=trade",
    },
    {
      icon: TbTrees,
      color: "timber",
      title: t("pathDevelopTitle"),
      description: t("pathDevelopDesc"),
      cta: t("pathDevelopCta"),
      href: "/register?intent=develop",
    },
  ]

  return (
    <Box py={80} bg="var(--mantine-color-body)">
      <Container size="lg">
        <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="lg">
          {pathways.map((p) => (
            <ActionCard
              key={p.href}
              icon={p.icon}
              color={p.color}
              title={p.title}
              description={p.description}
              variant="vertical"
              onClick={() => router.push(p.href)}
            >
              <Group gap={4} align="center" wrap="nowrap" mt="sm">
                <Text size="sm" c={p.color} fw={600}>{p.cta}</Text>
                <TbArrowRight size={14} color={`var(--mantine-color-${p.color}-6)`} />
              </Group>
            </ActionCard>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  )
}
